// third party
import { closeSnackbar, SnackbarProvider } from 'notistack';

// project imports
import { useSelector } from 'store';

// assets
import { IconCircleCheck, IconSquareRoundedX, IconInfoCircle, IconAlertCircle } from '@tabler/icons-react';
import { IconButton, styled, useTheme } from '@mui/material';
import { Close } from '@mui/icons-material';
import NotificationIcon from './NotificationIcon';

// ===========================|| SNACKBAR - NOTISTACK ||=========================== //

const StyledSnackbarProvider = styled(SnackbarProvider)(({ theme }) => ({
  '&.notistack-MuiContent-default': {
    backgroundColor: theme.palette.primary.main,
    color: `${theme.palette.getContrastText(theme.palette.primary.main)} !important`,
  },
  '&.notistack-MuiContent-error': {
    backgroundColor: theme.palette.error.main,
    color: `${theme.palette.getContrastText(theme.palette.error.main)} !important`,
  },
  '&.notistack-MuiContent-success': {
    backgroundColor: theme.palette.success.main,
    color: `${theme.palette.getContrastText(theme.palette.success.main)} !important`,
  },
  '&.notistack-MuiContent-info': {
    backgroundColor: theme.palette.info.main,
    color: `${theme.palette.getContrastText(theme.palette.info.main)} !important`,
  },
  // Server-driven funnerServiceNotification colors (inline --funner-service-* beat theme via variables)
  '&.notistack-MuiContent-info.funner-service-notification': {
    backgroundColor: 'var(--funner-service-bg, #2196f3)',
    color: 'var(--funner-service-fg, #ffffff) !important',
  },
  '&.notistack-MuiContent-warning': {
    backgroundColor: theme.palette.warning.main,
    color: `${theme.palette.getContrastText(theme.palette.warning.main)} !important`,
  },
}));

export default function Notistack({ children }: any) {
  const snackbar = useSelector((state) => state.snackbar);
  const iconSX = (_variant: string) => ({ marginRight: 8, fontSize: '1.15rem', color: '#ffffff' });
  const userConfig = useSelector((state) => state.userConfig);

  return (
    <StyledSnackbarProvider
      maxSnack={snackbar.maxStack}
      dense={snackbar.dense}
      iconVariant={
        snackbar.iconVariant === 'useemojis'
          ? {
              success: <IconCircleCheck style={iconSX('success')} />,
              error: <IconSquareRoundedX style={iconSX('error')} />,
              warning: <IconInfoCircle style={iconSX('warning')} />,
              info: <IconAlertCircle style={iconSX('info')} />,
            }
          : {
              success: <NotificationIcon type="success" />,
              error: <NotificationIcon type="error" />,
              warning: <NotificationIcon type="warning" />,
              info: <NotificationIcon type="info" />,
              default: <NotificationIcon type="default" />,
            }
      }
      action={(key) => (
        <IconButton size="small" aria-label="close" color="inherit" onClick={() => closeSnackbar(key)}>
          <Close fontSize="small" />
        </IconButton>
      )}
      autoHideDuration={userConfig.notifHintTimeout === 0 ? null : userConfig.notifHintTimeout * 1000}
      hideIconVariant={snackbar.iconVariant === 'hide' ? true : false}
      anchorOrigin={snackbar.anchorOrigin}
      sx={{
        justifyContent: 'space-between',
        fontSize: '14px',
        maxWidth: 420,
        flexWrap: 'nowrap !important',
      }}
    >
      {children}
    </StyledSnackbarProvider>
  );
}
